<mat-card>
  <mat-card-header>
    <mat-card-title>Reporte de Asistencias</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Desde</mat-label>
                <input matInput [matDatepicker]="fechaDesdePicker" formControlName="FechaDesde"  (click)="fechaDesdePicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaDesdePicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaDesde')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaDesdePicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%" >
                <mat-label>Fecha Hasta</mat-label>
                <input matInput [matDatepicker]="fechaHastaPicker" formControlName="FechaHasta"  (click)="fechaHastaPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaHastaPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaHasta')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaHastaPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <input type="text" placeholder="{{ 'Comunidad' | translate }}" aria-label="{{ 'Comunidad' | translate }}" (keyup)="filterComunidadList($event.target.value)" matInput [matAutocomplete]="comunidad" formControlName="Comunidades">
                <mat-hint style="display:flex;">
                  <p>{{ formatHintComunidades(selectedComunidades) }}</p>
                </mat-hint>
              </mat-form-field>

              <mat-autocomplete #comunidad="matAutocomplete" [displayWith]="displayComunidad">
                <mat-option *ngFor="let s of filteredComunidadesList" [value]="selectedComunidades">
                  <div (click)="comunidadSeleccionado($event, s)">
                    <mat-checkbox [checked]="s.selected" (change)="toggleComunidad(s)" (click)="$event.stopPropagation()">
                      {{ sharedFunctions.formatComunidadName(s) }}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </mat-autocomplete>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <input type="text" placeholder="Empleados" aria-label="Empleados" matInput [matAutocomplete]="empleados" formControlName="Empleados">
                <mat-hint style="display:flex;">
                  <p>{{ formatHintEmpleados(selectedEmpleados) }}</p>
                </mat-hint>
              </mat-form-field>

              <mat-autocomplete #empleados="matAutocomplete" [displayWith]="displayEmpleado">
                <mat-option *ngFor="let s of filteredEmpleadoList" [value]="selectedEmpleados">
                  <div (click)="empleadoSeleccionado($event, s)">
                    <mat-checkbox [checked]="s.selected" (change)="toggleEmpleado(s)" (click)="$event.stopPropagation()">
                      {{ s.Nombre.toUpperCase() }} {{ s.Apellido.toUpperCase() }} - {{formatCuit(s.Cuit.toString())}}
                    </mat-checkbox>
                  </div>
                </mat-option>
              </mat-autocomplete>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isGremiosSearching">Gremio</mat-label>
                <mat-label *ngIf="isGremiosSearching">Cargando...</mat-label>
                <mat-select formControlName="GremioId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of gremioList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isMotivoInasistenciaSearching">Motivo Inasistencia</mat-label>
                <mat-label *ngIf="isMotivoInasistenciaSearching">Cargando...</mat-label>
                <mat-select formControlName="MotivoInasistenciaId">
                  <mat-option>Todas</mat-option>
                  <mat-option *ngFor="let s of motivoInasistenciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isSubContratistaSearching">SubContratista</mat-label>
                <mat-label *ngIf="isSubContratistaSearching">Cargando...</mat-label>
                <input  type="text"
                        placeholder="Apellido o Nombre - Cuit"
                        aria-label="SubContratista"
                        matInput
                        formControlName="SubContratista"
                        [matAutocomplete]="subContratista">
                        <i [ngStyle]="{'display': isSubContratistaSearching ? 'inline-block' : 'none'}" class="fa fa-spinner fa-spin" style="position: absolute; right: 0"></i>
                <mat-autocomplete [displayWith]="displaySubContratista"
                                  autoActiveFirstOption
                                  #subContratista="matAutocomplete">
                  <mat-option
                    *ngFor="let s of filteredSubContratistaList" [value]="s">
                    {{s.Apellido | uppercase}} {{s.Nombre | uppercase}} - {{s.Cuit}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
            </div>

          </div>
          <div fxLayout="row stretch" fxLayout.xs="column">
            <mat-checkbox formControlName="Activo" color="primary" (keyup.enter)="onSearch()">Ver Solo Empleados Activos</mat-checkbox>
          </div>
        </form>

      </mat-expansion-panel>

      <div fxLayout="row" fxLayoutGap="10px" style="margin: 10px 0px;">
        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
          <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
          <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
        </div>
        <div fxLayout="row" fxLayoutAlign="end center" style="flex-grow: 1;">
          <mat-expansion-panel [expanded]="true" hideToggle="true">
            <div fxLayout="row stretch" fxLayout.xs="column">
              <mat-label style="margin-top: 15px;"><b>Cantidad de Días:</b> {{resultCount}}</mat-label>
            </div>
          </mat-expansion-panel>
        </div>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
        <ejs-grid #grid [dataSource]='data' [allowSorting]="true" [query]='query' [allowPaging]="true" [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
          [pageSettings]='pageSettings' [allowResizing]='true' (actionFailure)="onGridActionFailure($event)">
          <e-columns>
            <e-column field='FechaAsistencia' headerText='Fecha' width=90>
              <ng-template #template let-data>
                {{data.FechaAsistencia | date:'dd/MM/yyyy'}}
              </ng-template>
            </e-column>
            <e-column field='ComunidadNombre' headerText='Comunidad' width=90>
              <ng-template #headerTemplate let-data>
                <div>
                  {{ 'Comunidad' | translate }}
                </div>
              </ng-template>
            </e-column>
            <e-column field='GremioNombre' headerText='Gremio' width=90>
            </e-column>
            <e-column field='EmpleadoNombre' headerText='Empleado' width=90>
              <ng-template #template let-data>
                {{data.EmpleadoNombre.toUpperCase() + " " + data.EmpleadoApellido.toUpperCase()}}
              </ng-template>
            </e-column>
            <e-column field='Cuit' headerText='Cuit' width=90>
              <ng-template #template let-data>
                {{formatCuit(data.Cuit)}}
              </ng-template>
            </e-column>
            <e-column headerText='Presente' textAlign="center" width=90>
              <ng-template #template let-data>
                {{data.HorasPresente}}
              </ng-template>
            </e-column>
            <e-column headerText='Ausente' textAlign="center" width=90>
              <ng-template #template let-data>
                {{data.HorasAusente}}
              </ng-template>
            </e-column>
            <e-column field='MotivoInasistenciaNombre' headerText='Motivo Inasistencia' textAlign="center" width=90>
              <ng-template #template let-data>
                {{data.MotivoInasistenciaNombre}}
              </ng-template>
            </e-column>
            <e-column headerText='Total Horas' textAlign="center" width=90>
              <ng-template #template let-data>
                {{ data.TotalHoras }}
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </ng-container>

  </mat-card-content>
</mat-card>
